import EditIcon from "@mui/icons-material/Edit";
import {
  AdminItemsRow,
  AdminItemsContainer,
  AdminItemContainer,
} from "../../admin.styled";
import { useState } from "react";
import {
  IconButton,
} from "@mui/material";

export function AdminIauRow({ iau }) {
    const [openRow, setRowOpen] = useState(false);

    return (
        <AdminItemsRow>
            <div className="unexpanded-row-container">
                <div className="row-items" onClick={() => setRowOpen(!openRow)}>
                    <p className="row-item">{iau.options.description}</p>
                    <p className="row-item">{iau.name}</p>
                    <p className="row-item">{iau.options.org}</p>
                </div>
                <div className="row-buttons">
                </div>
            </div>

            {openRow && (
                <AdminItemsContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Module:</strong>
                        <p className="ps-1">{iau.module}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Nice Name:</strong>
                        <p className="ps-1">{iau.options.nice_name}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Description:</strong>
                        <p className="ps-1">{iau.options.description}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Org:</strong>
                        <p className="ps-1">{iau.options.org}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Use:</strong>
                        <p className="ps-1">{iau.options.use ? "True" : "False"}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Accepts Text:</strong>
                        <p className="ps-1">{iau.options.accepts_text ? "True" : "False"}</p>
                    </AdminItemContainer>
                    <AdminItemContainer className="d-flex flex-row">
                        <strong>Accepts Files:</strong>
                        <p className="ps-1">{iau.options.accepts_files ? "True" : "False"}</p>
                    </AdminItemContainer>
                    <AdminItemContainer>
                        <strong>Access:</strong>
                        <ul>
                            {iau.options.access.map((access, index) => (
                                <li key={index}>{access}</li>
                            ))}
                        </ul>
                    </AdminItemContainer>
                    <AdminItemContainer>
                        <strong>Models:</strong>
                        <ul>
                            {iau.options.models.map((model, index) => (
                                <li key={index}>{model}</li>
                            ))}
                        </ul>
                    </AdminItemContainer>
                </AdminItemsContainer>
            )}
        </AdminItemsRow>
    );
}